import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { AttendancePage } from '@/features/attendance/attendance-page';

const searchSchema = z.object({
  /** Opens the day sheet (approval) for this date. */
  date: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .optional()
    .catch(undefined),
});

export const Route = createFileRoute('/_app/projects/$projectId/site/attendance')({
  validateSearch: searchSchema,
  component: AttendanceRoute,
});

function AttendanceRoute() {
  const { projectId } = Route.useParams();
  const { date } = Route.useSearch();
  return <AttendancePage projectId={projectId} sheetDate={date} />;
}
